/**
 * Verifica si la membresía de una empresa está suspendida comparando
 * la fecha de vencimiento (fecVen) con la fecha actual.
 * @param {object} empresa - El objeto de la empresa que contiene los datos de la membresía.
 * @returns {boolean} - Devuelve true si la membresía está suspendida, de lo contrario false.
 */
export const isMembresiaSuspendida = (empresa) => {
  if (!empresa) {
    return false;
  }

  // 1. Si la empresa tiene fecha de vencimiento (fecVen), esta manda sobre el estado del trial/suscripción
  if (empresa.fecVen) {
    try {
      let fechaVencimiento;
      if (typeof empresa.fecVen.toDate === 'function') {
        fechaVencimiento = empresa.fecVen.toDate();
      } else {
        fechaVencimiento = new Date(empresa.fecVen);
      }

      if (!isNaN(fechaVencimiento.getTime())) {
        const fechaActual = new Date();
        fechaVencimiento.setHours(0, 0, 0, 0);
        fechaActual.setHours(0, 0, 0, 0);
        return fechaVencimiento < fechaActual;
      }
    } catch (error) {
      console.error("Error al procesar la fecha de vencimiento:", error);
    }
  }

  // 2. Si no tiene fecVen directa pero tiene el nuevo objeto de suscripción
  if (empresa.subscription) {
    if (empresa.subscription.status === 'expired') {
      return true;
    }
    if (empresa.subscription.status === 'trial' && empresa.subscription.trialEnd) {
      try {
        let fechaVencimientoPrueba;
        if (typeof empresa.subscription.trialEnd.toDate === 'function') {
          fechaVencimientoPrueba = empresa.subscription.trialEnd.toDate();
        } else {
          fechaVencimientoPrueba = new Date(empresa.subscription.trialEnd);
        }

        if (!isNaN(fechaVencimientoPrueba.getTime())) {
          const fechaActual = new Date();
          fechaVencimientoPrueba.setHours(0, 0, 0, 0);
          fechaActual.setHours(0, 0, 0, 0);
          return fechaVencimientoPrueba < fechaActual;
        }
      } catch (error) {
        console.error("Error al procesar la fecha de vencimiento de prueba:", error);
      }
    }
    return false;
  }

  return false;
};

